<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10Q4tbf/tc-custom/9781429998604.jpg?1733082395228" alt="This image is the cover for the book Sailor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sailor
      </h1>
      <p class="bookDescription body article font2">
        <p> Acclaimed novelist of <i>The Kind One</i> and screenwriter of such films as <i>One False Move</i> and <i>The Gift,</i> Tom Epperson brings the violence-soaked world of Cormac McCarthy's <i>No Country for Old Men </i>and the heroism of Jack Schaefer's <i>Shane</i> together to create an iconic action thriller for the twenty-first century.<br/><br/> Gina fell for the wrong guy. Joe came into her life promising her everything, and he gave it to her, along with a world of hell.<br/><br/> But Gina was stronger than Joe realized. After years of suffering the terror of being married to a criminal, she took the one thing he ever gave her that she wanted—her son, Luke. Then she turned the bastard in.<br/><br/> With her husband behind bars, her father-in-law will stop at nothing for revenge.<br/><br/> He wants his grandson back, the heir to his criminal empire. With a vast network that stretches across the country, every favor is called in to kill Gina and return Luke to his grandfather.<br/><br/> Gina can trust no one. Even the U.S. Marshall assigned to keep Gina and Luke safe is on the payroll.<br/><br/> So with a gun and stolen diamonds in her purse, and derelicts, the law, and hit men on her tail, Gina takes Luke and runs.<br/><br/> Los Angeles was only supposed to be a quick stop—sleep, eat, and continue running—but then they meet Gray….<br/><br/> He says he's a sailor, but he seems to be hiding a lot. And when the time comes, he's the only thing standing between her and the grave. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Epperson
      </h2>
      
      <p class="authorDescription body article"><P>Tom Epperson is the cowriter, with Billy Bob Thornton, of <I>A Family Thing </I>(starring Robert Duvall and James Earl Jones, nominated for the Humanitas Prize), <I>One False Move </I>(named as one of the year's best films by a number of top critics), and <I>The Gift </I>(directed by Sam Raimi, and starring Cate Blanchett, Keanu Reeves, and Hillary Swank). Epperson's first book, <I>The Kind One</I><I>,</I> was nominated for an Edgar and a Barry Award in 2009. He lives in Los Angeles.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39311578